import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource';


import {ConfigInterface} from "@/store/module/interface/config.interface";
import {ConfigCommit} from "@/store/module/enum/config-commit.enum";
import {ModalPlugin, DropdownPlugin} from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto';

import './assets/scss/main.scss';

Vue.config.productionTip = false;
// @ts-ignore
import VueGAPI from 'vue-gapi';

const config = {
  apiKey: 'AIzaSyAU5Hi_IF-JEaTqufDN2Emea0uNpKrfZiY',
  clientId: '640935328176-lutcuiqiab6pcsq2i19ffj61d61sj8ci.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/spreadsheets',
  discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4']
};

Vue.use(VueGAPI, config);
Vue.use(VueResource);
Vue.use(ModalPlugin);
Vue.use(DropdownPlugin);
Vue.use(VueScrollTo);
(Vue as any).http.options.emulateJSON = true;

(Vue as any).http.get(process.env.VUE_APP_FRONT_END_CONFIG_URL)
  .then((response: any) => response.json())
  .then((config: ConfigInterface) => {
    store.commit(ConfigCommit.SET_CONFIG, config);
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  })
